import { StarDecoration } from "../star-decoration"

export function StarsDesktop() {
  return (
    <div className="hidden md:block">
      <div className="absolute bottom-[15%] left-[-5%] sm:block">
        <StarDecoration width={26} height={26} />
      </div>
      <div className="absolute left-[80%] top-[10%] sm:block lg:left-[45%] lg:top-[0%]">
        <StarDecoration width={76} height={76} />
      </div>
    </div>
  )
}
